import React from 'react';
import { Box, Typography, Button, useMediaQuery } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
//import logo from '../assets/banner1.png';

const SupplierJoinPromo = () => {
    
    const isMobile = useMediaQuery('(max-width:768px)');
    
  return (
    <Box sx={styles.promoContainer}>
      <Box sx={styles.contentBox}>
                <img
            src={!isMobile ? "../images/foodsakzsidegraylogo.png" : "../images/mobilelogo.png"}
            alt="Logo"
            width={350}
            height={120}
            style={{
              marginBottom: 20,
            }}
          />
       
        <Typography variant="h5" component="p" sx={styles.promoText}>
          **Join the Foodsakz Network**
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Access thousands of new buyers in Chennai and streamline your logistics. Fast, easy, and free to register!
        </Typography>

      </Box>
    </Box>
  );
};

const styles = {
  promoContainer: {
    // Style to fill horizontal space and create a visual break
    width: '100%',
    padding: 3, 
    mt: 4, // Margin Top to separate from the form above
    mb: 4, // Margin Bottom
    backgroundColor: '#F0FFF0', // Very light green background
    border: '1px dashed #A5D6A7', // Dashed border for promo feel
    borderRadius: 1,
    textAlign: 'center',
  },
  contentBox: {
    maxWidth: 600,
    mx: 'auto', // Center the content horizontally
  },
  icon: {
    fontSize: 40,
    color: '#388E3C', // Green theme color
    mb: 1,
  },
  promoText: {
    color: '#388E3C', // Darker green for headline
    fontWeight: 600,
    mb: 1,
  },
  promoButton: {
      fontWeight: 'bold',
      // Ensure the button is small and matches the brand color
  }
};

export default SupplierJoinPromo;